import {defaultConfiguration, defaultConfigurationModules, IConfiguration} from "../configuration.state";
const CONFIGURATION_AUCHAN_RO: IConfiguration = {
  ...defaultConfiguration,
  api: {
    ...defaultConfiguration.api,
    protocol: 'https',
    port: '443'
  },
  theme: 'auchan',
  language: {
    defaultLang: 'ro',
    showLang: true,
    langList: ['en', 'ru', 'ro', 'ua']
  },
  pagesConfig: {
    ...defaultConfigurationModules,
    login: {
      ...defaultConfigurationModules.login,

      loginType: 'common',
      goFAQ: '',
      supportEmail: 'support_ro@auchan.ro',
      enableSelfRegistration: false,
      enableGoogleSignIn: false,
      showTutorialVideo: false,
      showTryDemoButton: false,
      showAboutUsButton: false,
      showContacts: false,
      showContactOnlyEmail: true,

      contactsConfig: {
        showViber: false,
        showPhone: false,
        showEmail: true
      }
    },
    main: {
      showSupportBlock: true,
    },
    dataLedger: {
      ...defaultConfigurationModules.dataLedger,
      showSuppliersCodeForPartner: true
    }
  }
};


export const CONFIGURATION_AUCHAN_RO_ADMIN_INTERNAL:IConfiguration = {
  ...CONFIGURATION_AUCHAN_RO,
  api: {
    ...CONFIGURATION_AUCHAN_RO.api,
    protocol: 'http',
    port: '80'
  },
  auth:{
    realm: 'auchan_ro',
    module: 'ad'
  },
  pagesConfig:{
    ...defaultConfigurationModules,
    login:{
      ...defaultConfigurationModules.login,
      enableRestorePassword: false
    }
  }
};
export const CONFIGURATION_AUCHAN_RO_CLIENT_INTERNAL:IConfiguration = {
  ...CONFIGURATION_AUCHAN_RO,
  api: {
    ...CONFIGURATION_AUCHAN_RO.api,
    protocol: 'http',
    port: '80'
  },
  auth:{
    realm: 'auchan_ro',
    module: 'ldap'
  }
};
export const CONFIGURATION_AUCHAN_RO_CLIENT_EXTERNAL:IConfiguration = {
  ...CONFIGURATION_AUCHAN_RO,
  api: {
    ...CONFIGURATION_AUCHAN_RO.api,
    protocol: 'https',
    port: '443'
  },
  auth:{
    realm: 'auchan_ro',
    module: 'ldap'
  }
};

